import addRoute from '@/router/add-route';

const Automations = () => import('@/modules/automations/automations.vue');

const automations = [
    addRoute({
        name: 'automations',
        path: '/automations',
        component: Automations,
    }),
];

export default automations;
